// Field schemas for each admin resource. Used by ResourceManager to render forms.

export const RESOURCES = {
  services: {
    label: "Servicii",
    endpoint: "/admin/services",
    primaryKey: "slug",
    listColumns: ["order", "slug", "title_ro", "active"],
    fields: [
      { name: "slug", type: "text", label: "Slug (ex: expertize)", required: true },
      { name: "order", type: "number", label: "Ordine afișare", default: 0 },
      { name: "icon", type: "select", label: "Iconiță", options: ["gavel", "line-chart", "map"], default: "gavel" },
      { name: "active", type: "boolean", label: "Activ", default: true },
      { name: "title_ro", type: "text", label: "Titlu (RO)", required: true },
      { name: "title_en", type: "text", label: "Titlu (EN)", required: true },
      { name: "desc_ro", type: "textarea", label: "Descriere (RO)", required: true },
      { name: "desc_en", type: "textarea", label: "Descriere (EN)", required: true },
      { name: "bullets_ro", type: "list", label: "Bullete (RO, separate prin |)" },
      { name: "bullets_en", type: "list", label: "Bullets (EN, separated by |)" },
    ],
  },
  tools: {
    label: "Echipament",
    endpoint: "/admin/tools",
    primaryKey: "slug",
    listColumns: ["order", "slug", "name", "active"],
    fields: [
      { name: "slug", type: "text", label: "Slug", required: true },
      { name: "order", type: "number", label: "Ordine afișare", default: 0 },
      { name: "active", type: "boolean", label: "Activ", default: true },
      { name: "name", type: "text", label: "Nume produs", required: true },
      { name: "category_ro", type: "text", label: "Categorie (RO)", required: true },
      { name: "category_en", type: "text", label: "Category (EN)", required: true },
      { name: "desc_ro", type: "textarea", label: "Descriere (RO)", required: true },
      { name: "desc_en", type: "textarea", label: "Description (EN)", required: true },
    ],
  },
  "case-studies": {
    label: "Studii de caz",
    endpoint: "/admin/case-studies",
    primaryKey: "slug",
    listColumns: ["order", "year", "slug", "title_ro", "active"],
    fields: [
      { name: "slug", type: "text", label: "Slug", required: true },
      { name: "order", type: "number", label: "Ordine afișare", default: 0 },
      { name: "active", type: "boolean", label: "Activ", default: true },
      { name: "year", type: "number", label: "An", required: true, default: 2025 },
      { name: "service_slug", type: "select", label: "Serviciu asociat", options: ["", "expertize", "evaluare", "cartografie"] },
      { name: "title_ro", type: "text", label: "Titlu (RO)", required: true },
      { name: "title_en", type: "text", label: "Titlu (EN)", required: true },
      { name: "summary_ro", type: "textarea", label: "Sumar (RO)", required: true },
      { name: "summary_en", type: "textarea", label: "Summary (EN)", required: true },
      { name: "location_ro", type: "text", label: "Locație (RO)" },
      { name: "location_en", type: "text", label: "Location (EN)" },
      { name: "tools", type: "list", label: "Unelte/Software folosite (separate prin |)" },
      { name: "image_key", type: "select", label: "Imagine de fundal (placeholder)", options: ["hero", "accident", "blueprint", "topo", "drone"], default: "hero" },
      { name: "images", type: "list", label: "URL-uri imagini reale (separate prin |, prima este cover)" },
      { name: "video_url", type: "text", label: "Link video simulare (YouTube sau Vimeo)" },
    ],
  },
  faqs: {
    label: "Întrebări frecvente",
    endpoint: "/admin/faqs",
    primaryKey: "slug",
    listColumns: ["order", "slug", "question_ro"],
    fields: [
      { name: "slug", type: "text", label: "Slug", required: true },
      { name: "order", type: "number", label: "Ordine afișare", default: 0 },
      { name: "service_slug", type: "select", label: "Serviciu asociat", options: ["", "expertize", "evaluare", "cartografie"] },
      { name: "question_ro", type: "text", label: "Întrebare (RO)", required: true },
      { name: "question_en", type: "text", label: "Question (EN)", required: true },
      { name: "answer_ro", type: "textarea", label: "Răspuns (RO)", required: true },
      { name: "answer_en", type: "textarea", label: "Answer (EN)", required: true },
    ],
  },
  gallery: {
    label: "Galerie cartografie",
    endpoint: "/admin/gallery",
    primaryKey: "slug",
    listColumns: ["order", "slug", "size", "title_ro", "active"],
    fields: [
      { name: "slug", type: "text", label: "Slug (ex: ortofoto-dn6-2024)", required: true },
      { name: "order", type: "number", label: "Ordine afișare", default: 0 },
      { name: "active", type: "boolean", label: "Activ", default: true },
      { name: "image_url", type: "text", label: "URL imagine (Imgur, Google Drive direct, etc.)", required: true },
      { name: "size", type: "select", label: "Mărime în grid", options: ["small", "wide", "half", "large"], default: "small" },
      { name: "title_ro", type: "text", label: "Titlu (RO)", required: true },
      { name: "title_en", type: "text", label: "Title (EN)", required: true },
      { name: "tag_ro", type: "text", label: "Etichetă (RO, opțional)" },
      { name: "tag_en", type: "text", label: "Tag (EN, optional)" },
    ],
  },
};
